import React from 'react';
import { UsersIcon, StarIcon, BookOpenIcon, ShieldCheckIcon } from 'lucide-react';
export function SocialProof() {
  return <section className="bg-white py-8 border-b border-gray-100 shadow-sm relative z-20 -mt-4 rounded-t-3xl md:rounded-none md:mt-0" data-id="element-257">
      <div className="max-w-6xl mx-auto px-4" data-id="element-258">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center divide-x divide-gray-100" data-id="element-259">
          <div className="flex flex-col items-center justify-center" data-id="element-260">
            <div className="bg-blue-50 p-2.5 rounded-full mb-2" data-id="element-261">
              <UsersIcon className="w-5 h-5 text-blue-600" data-id="element-262" />
            </div>
            <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-0.5" data-id="element-263">
              +2.500
            </h3>
            <p className="text-xs md:text-sm text-gray-500 font-medium" data-id="element-264">
              Insegnanti Soddisfatti
            </p>
          </div>

          <div className="flex flex-col items-center justify-center" data-id="element-265">
            <div className="bg-yellow-50 p-2.5 rounded-full mb-2" data-id="element-266">
              <StarIcon className="w-5 h-5 text-yellow-500 fill-yellow-500" data-id="element-267" />
            </div>
            <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-0.5" data-id="element-268">
              4.9/5
            </h3>
            <p className="text-xs md:text-sm text-gray-500 font-medium" data-id="element-269">
              Valutazione Media
            </p>
          </div>

          <div className="flex flex-col items-center justify-center" data-id="element-270">
            <div className="bg-green-50 p-2.5 rounded-full mb-2" data-id="element-271">
              <BookOpenIcon className="w-5 h-5 text-green-600" data-id="element-272" />
            </div>
            <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-0.5" data-id="element-273">
              +300
            </h3>
            <p className="text-xs md:text-sm text-gray-500 font-medium" data-id="element-274">
              Risorse Incluse
            </p>
          </div>

          <div className="flex flex-col items-center justify-center" data-id="element-275">
            <div className="bg-blue-50 p-2.5 rounded-full mb-2" data-id="element-276">
              <ShieldCheckIcon className="w-5 h-5 text-blue-600" data-id="element-277" />
            </div>
            <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-0.5" data-id="element-278">
              100%
            </h3>
            <p className="text-xs md:text-sm text-gray-500 font-medium" data-id="element-279">
              Garanzia di Rimborso
            </p>
          </div>
        </div>
      </div>
    </section>;
}